import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Button } from 'react-bootstrap';
import { sluggify } from 'utils/localization/utils';

class JobDetailsHeader extends Component {
  render() {
    const {
      job: { current_status },
      closeButtonVisible,
      t,
    } = this.props;
    return (
      <div className="job_details__header items-center px-4">
        <div className="job_details__header__text">
          <span className="job_details__header__customer_reference_number">
            {this.props.job.shipment_id}
          </span>
          <span className="job_details__header__customer_reference_number">
            {t('REF')}: {this.props.customerReferenceNumber}
          </span>
        </div>
        <div className="job_details__header__buttons">
          <div className="flex justify-between">
            {this.props.isShipper && (
              <Button
                bsStyle="info"
                className="job_details__header__share_button mr-4"
                onClick={() => this.props.onOpenShare()}
              >
                {t('SHARE')}
              </Button>
            )}
            <div className="job_details__header__text">
              <span className="job_details__header__customer_reference_number">
                {t(sluggify(current_status))}
              </span>
            </div>
          </div>
          {closeButtonVisible && (
            <button
              className="font-bold text-white text-lg"
              onClick={this.props.onClose}
            >
              <span>&times;</span>
            </button>
          )}
        </div>
      </div>
    );
  }
}

JobDetailsHeader.propTypes = {
  isShipper: PropTypes.bool,
  job: PropTypes.shape({
    shipment_id: PropTypes.string.isRequired,
  }).isRequired,
  customerReferenceNumber: PropTypes.string.isRequired,
  onOpenShare: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  closeButtonVisible: PropTypes.bool.isRequired,
};

export default withTranslation()(JobDetailsHeader);
